export function dataInRequest(params = {}) {
  return {
    type: '@transportadora/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@transportadora/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@transportadora/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@transportadora/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@transportadora/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@transportadora/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@transportadora/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@transportadora/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@transportadora/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@transportadora/RECORD_FILTERING',
    payload: { params },
  };
}
